var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconGrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.22395833,10.0625 L6.70833333,10.0625 C6.24521956,10.0625 5.86979167,9.68707211 5.86979167,9.22395833 L5.86979167,6.70833333 C5.86979167,6.24521956 6.24521956,5.86979167 6.70833333,5.86979167 L9.22395833,5.86979167 C9.68707211,5.86979167 10.0625,6.24521956 10.0625,6.70833333 L10.0625,9.22395833 C10.0625,9.68707211 9.68707211,10.0625 9.22395833,10.0625 Z M9.22395833,4.19270833 L6.70833333,4.19270833 C6.24521956,4.19270833 5.86979167,3.81728044 5.86979167,3.35416667 L5.86979167,0.838541667 C5.86979167,0.375427892 6.24521956,0 6.70833333,0 L9.22395833,0 C9.68707211,0 10.0625,0.375427892 10.0625,0.838541667 L10.0625,3.35416667 C10.0625,3.81728044 9.68707211,4.19270833 9.22395833,4.19270833 Z M3.35416667,10.0625 L0.838541667,10.0625 C0.375427892,10.0625 0,9.68707211 0,9.22395833 L0,6.70833333 C0,6.24521956 0.375427892,5.86979167 0.838541667,5.86979167 L3.35416667,5.86979167 C3.81728044,5.86979167 4.19270833,6.24521956 4.19270833,6.70833333 L4.19270833,9.22395833 C4.19270833,9.68707211 3.81728044,10.0625 3.35416667,10.0625 Z M3.35416667,4.19270833 L0.838541667,4.19270833 C0.375427892,4.19270833 0,3.81728044 0,3.35416667 L0,0.838541667 C0,0.375427892 0.375427892,0 0.838541667,0 L3.35416667,0 C3.81728044,0 4.19270833,0.375427892 4.19270833,0.838541667 L4.19270833,3.35416667 C4.19270833,3.81728044 3.81728044,4.19270833 3.35416667,4.19270833 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Empty-state",
    transform: "translate(-208.000000, -171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconGrid",
    transform: "translate(208.468750, 171.468750)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/iconGrid.acdf498c577565f34cb814ed1182827f.svg";
export { ForwardRef as ReactComponent };